import loadable from '@loadable/component'

export const LazyBreachWallContentWrapper = loadable(
    () => import('./BreachWallContentWrapper'),
)
